export default function () {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;
  const clientPath = SITEBASEURL;

  const breakpoint = 800;
  const isDesktopScreen = $(window).width() >= breakpoint;
  const wrapContainerClass = 'cards-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    moreButton: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      if (widgetData.length <= 0) {
        $('body').addClass(`${$widget}-no-data`);
        $(`.${wrapContainerClass}`).remove();
      } else {
        createCustomCards(widgetData);
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];

      const $cardItem = $(this);
      $cardItem.find('.image-container').append('<div class="overlay"></div>');
      $cardItem.find('.card-content').remove();
      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
              ${URL ? `<a href="${URL}" target="_blank" class="button">More</a>` : ''}
            </div>
          </div>`);

      if (!URL) {
        $cardItem.addClass('empty-card').removeAttr('href');
      } else {
        const isSameDomain = URL.startsWith(clientPath);

        if (isSameDomain) {
          $cardItem.find('.button').removeAttr('target');
        } else {
          $cardItem.find('.button').attr('target', '_blank');
        }
      }
    });
  }
}
